(function () {
  'use strict';

  // Variant-only (Single Source of Truth, kein Produkt-Fallback).
  function resolveKategorie(variant) {
    var c = variant && variant.metafields && variant.metafields.custom;
    return (c && c.widerruf_kategorie) || null;
  }

  // Schaltet beide Consent-Blöcke + den Express-Block für die gewählte Kategorie.
  // Aktiver Block: sichtbar + Input required+enabled. Inaktiv: hidden + disabled +
  // ungecheckt (disabled => nicht submitted/validiert). Express: hidden wenn Kategorie gesetzt.
  function apply(root, kategorie) {
    var blocks = root.querySelectorAll('[data-consent-for]');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var input = block.querySelector('[data-consent-input]');
      if (block.getAttribute('data-consent-for') === kategorie) {
        block.removeAttribute('hidden');
        if (input) { input.disabled = false; input.required = true; }
      } else {
        block.setAttribute('hidden', '');
        if (input) { input.checked = false; input.required = false; input.disabled = true; }
      }
    }
    var express = root.querySelector('[data-express-block]');
    if (express) {
      if (kategorie) express.setAttribute('hidden', '');
      else express.removeAttribute('hidden');
    }
  }

  function bind(root) {
    if (root.dataset.widerrufBound) return;
    if (!root.querySelector('[data-widerruf-consent]')) return;
    root.dataset.widerrufBound = '1';
    root.addEventListener('trautis:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      apply(root, v ? resolveKategorie(v) : null);
    });
  }

  function init() { document.querySelectorAll('[data-product-section]').forEach(bind); }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  window.TrautisWiderrufConsent = { resolveKategorie: resolveKategorie };
})();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = (typeof window !== 'undefined' && window.TrautisWiderrufConsent) || { resolveKategorie: function () { return null; } };
}
